import { contractPeriodOptions, preOrderPeriodOptions, getProductType, isNLD_OR_LL, isVPN_OR_DI, PRODUCT_TYPE, VPN_SITE_TYPE, isPreOrder } from 'common/constants/app.constants';
import { SERVICE_OPTIONS } from 'dedicated/components/choose-plan/formControl';

const PARTIALLY_MANAGED = 'PARTIALLY_MANAGED';

export const getContractPeriod = (records: Array<any>): any => {
  if (Array.isArray(records) && records.length === 1) {
    return contractPeriodOptions.find((contract) => {
      return contract.displayName === records[0].contractPeriod || contract.displayName === records[0].contractPeriod + 's';
    });
  }
  return contractPeriodOptions[0];
};

export const getPreOrderPeriod = (records: Array<any>): any => {
  if (Array.isArray(records) && records.length === 1) {
    return preOrderPeriodOptions.find((contract) => {
      return contract.displayName === records[0].preOrderDuration || contract.displayName === records[0].preOrderDuration + 's';
    });
  }
  return preOrderPeriodOptions[0];
};

export const getServiceType = (records: Array<any>): any => {
  if (Array.isArray(records) && records.length === 1) {
    return SERVICE_OPTIONS.find((service) => {
      return service.id === records[0].service;
    });
  }
  return SERVICE_OPTIONS[0];
};

export const getServiceOptions = () => {
  // let ignoreService = '';
  // const isProductDedicated = getProductType() === PRODUCT_TYPE.DEDICATED_INTERNET;
  // if (isProductDedicated) {
  //   ignoreService = PARTIALLY_MANAGED;
  // }
  // return SERVICE_OPTIONS?.filter(({ id }) => {
  //   return id !== ignoreService;
  // });
  if (isPreOrder()) {
    return SERVICE_OPTIONS.filter((item) => item.id !== 'MANAGED');
  }

  return SERVICE_OPTIONS;
};

export const getTotalLinks = (records: Array<any>) => {
  if (isNLD_OR_LL()) {
    return Math.floor(records?.length / 2);
  } else if (isVPN_OR_DI()) {
    const primaryLinkCount = records?.filter((record) => {
      return record?.siteType === VPN_SITE_TYPE.PRIMARY;
    }).length;
    return primaryLinkCount;
  }
  return records?.length;
};
